import { z } from 'zod';
import { FlowWithDefinitionsSchema, FlowWithRunCountSchema } from './flow.js';
import { FlowFindAllQueryParamsSchema, FlowIdParamsSchema, GetFlowByIdQueryParamsSchema, } from './flowRequests.js';
const TAGS = ['Flow'];
export const FLOWS_BASE_ROUTE = '/flows';
export const FlowCreateRoute = {
    method: 'post',
    fullPath: FLOWS_BASE_ROUTE,
    summary: 'Create a flow',
    tags: TAGS,
};
export const FlowListRoute = {
    method: 'get',
    fullPath: FLOWS_BASE_ROUTE,
    summary: 'List flows',
    tags: TAGS,
    query: FlowFindAllQueryParamsSchema.strict(),
    response: z.array(FlowWithRunCountSchema),
};
export const FlowGetRoute = {
    method: 'get',
    fullPath: `${FLOWS_BASE_ROUTE}/:id`,
    summary: 'Get a flow and its definition metadata by id',
    description: 'Returns one accessible flow and metadata for its flow-definition versions without executable block graphs. Always set flowDefinitionLimit to bound the response, and set flowDefinitionOrderDirection when version order matters. Retrieve a selected definition by its id to load its complete graph. flow.liveDefinitionId identifies the published definition and may differ from the latest version.',
    tags: TAGS,
    params: FlowIdParamsSchema,
    query: GetFlowByIdQueryParamsSchema.strict(),
    response: FlowWithDefinitionsSchema,
};
export const FlowUpdateRoute = {
    method: 'patch',
    fullPath: `${FLOWS_BASE_ROUTE}/:id`,
    summary: 'Update a flow',
    tags: TAGS,
    params: FlowIdParamsSchema,
};
//# sourceMappingURL=routes.js.map